import React, { Component } from 'react'
import PreInternal from '../build/images/atendimento_splash.png'

export default class ChatInternal extends Component {

render(){   
    return( 
       <div id="column2" className="chat-page column split column-chat">
          <div className="center">
            <div className="center__item">
              <img src={PreInternal} />
            </div>
          </div>
       </div>
    )}               
}

